import React, {useEffect} from "react";
import {
    useSearchProductionOrderAnalysisByTimeReportPageQuery,
    useSearchProductionStagesGuidePageQuery
} from "../../store/backend-api/backend.api";
import {useFiltersActions} from "../../hooks/useFiltersActions";
import {useAppSelector} from "../../hooks/useAppSelector";
import {TableFilterKey} from "../../model/filters/TableFiltersDefinitions";
import {GuideTopBox} from "../../components/ui/table-components/GuideTopBox";
import {useFilterNodesActions} from "../../hooks/useMenuFiltersActions";
import {productionOrderStatusToString} from "../../data/ProductionOrderData";
import {useDataActions} from "../../hooks/useDataActions";
import {
    DEFAULT_PRODUCTION_ORDER_ANALYSIS_BY_TIME_FILTER,
    DEFAULT_PRODUCTION_STAGE_GUIDE_FILTER
} from "../../model/filters/DefaultFilters";
import {MultiSelect} from "../../components/ui/form-components/standalone/MultiSelect";
import {OptionType} from "../../model/option-type/OptionType";
import {ProductionOrderStatus} from "../../model/production-order/ProductionOrder";
import {
    ProductionOrderAnalysisByTimeTable
} from "../../components/production-order-analysis-by-time/ProductionOrderAnalysisByTimeTable";
import {tablePageStyle} from "../../utils/TailwindStyles";

export function ProductionOrderAnalysisByTimeReport() {
    const {updateFilterAndClearData} = useFiltersActions()
    const {addFiltersToMenu} = useFilterNodesActions()
    const {addData} = useDataActions()

    const state = useAppSelector(state => state.sessionStorage.filters)
    const filter = state[TableFilterKey.PRODUCTION_ORDER_ANALYSIS_BY_TIME_FILTER].filter;

    const data = useAppSelector(state => state.data.data[TableFilterKey.PRODUCTION_ORDER_ANALYSIS_BY_TIME_FILTER
        ])

    const {data: tablePage} = useSearchProductionOrderAnalysisByTimeReportPageQuery(filter)
    const {data: productionStages} = useSearchProductionStagesGuidePageQuery({...DEFAULT_PRODUCTION_STAGE_GUIDE_FILTER, pageSize: 1000})

    const selectOptions = Array.from(productionOrderStatusToString.keys()).map(key => ({
        label: productionOrderStatusToString.get(key)!,
        value: key
    }))

    useEffect(() => {
        addFiltersToMenu({
            key: TableFilterKey.PRODUCTION_ORDER_ANALYSIS_BY_TIME_FILTER,
            value: [
                {
                    filterName: "Статус заказа",
                    filter: <MultiSelect options={selectOptions}
                                         onChange={(options: readonly OptionType<ProductionOrderStatus>[] | null) => {
                                             updateFilterAndClearData({
                                                 key: TableFilterKey.PRODUCTION_ORDER_ANALYSIS_BY_TIME_FILTER,
                                                 value: {
                                                     ...filter,
                                                     status: options ? options.map(option => option.value) : []
                                                 }
                                             })
                                         }}
                                         width={"270px"}
                                         defaultOptions={filter.status.map(status => ({
                                             label: productionOrderStatusToString.get(status)!,
                                             value: status
                                         }))}
                    />
                }
            ]
        })
    }, [filter]);

    useEffect(() => {
        if (tablePage) {
            if (!data || data.rows.length < (tablePage.pageNumber * DEFAULT_PRODUCTION_ORDER_ANALYSIS_BY_TIME_FILTER.pageSize) + 1) {
                addData({key: TableFilterKey.PRODUCTION_ORDER_ANALYSIS_BY_TIME_FILTER, data: tablePage})
            }
        }

    }, [tablePage]);

    return (<>
        <div className={tablePageStyle}>
            <GuideTopBox tableFilterKey={TableFilterKey.PRODUCTION_ORDER_ANALYSIS_BY_TIME_FILTER}
                         searchInfo={"Поиск по П/№, № Work и основной продукции."}/>
            {data && productionStages &&
                <ProductionOrderAnalysisByTimeTable data={data} productionStages={productionStages.rows}/>}
        </div>
    </>)
}